module.exports = __webpack_public_path__ + "img/triangle.4389ca07.svg";